/*
  Reveal-on-scroll for Echo Partners sections.

  snippets/partners-base-css.liquid may emit this <script src> once per
  partners section on the page, so the body is guarded: the first tag to run
  does the work, the rest return immediately.
*/
(function () {
  'use strict';
  if (window.__epPartnersBaseInit) return;
  window.__epPartnersBaseInit = true;
  var sections = document.querySelectorAll('.ep-section');
  sections.forEach(function(s){ s.classList.add('js-ready'); });
  var ro = new IntersectionObserver(function(entries){
    entries.forEach(function(e){ if(e.isIntersecting){e.target.classList.add('v');ro.unobserve(e.target);} });
  },{threshold:0.08,rootMargin:'0px 0px -36px 0px'});
  document.querySelectorAll('.ep-section .r,.ep-section .rl,.ep-section .rr').forEach(function(el){ro.observe(el);});
})();
